<template>
  <div class="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style scoped lang="scss">
  .app {
    height: 100%;
  }
</style>